import EditIcon from '@mui/icons-material/Edit';
import { Button,Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { useContext,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../context/UserContext';
import { trackEventMatomo } from '../../helpers/matomo';
import ModalAssinatura from './ModalAssinatura';
import { UserCardContainer } from './UserCardStyle';

export default function UserCard() {
  const { userData, isHidden } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('translation');

  const handleChange = () => {
    trackEventMatomo('navegação global', 'click', 'botão', open ? 'fecha configuração de assinatura' : 'abre configuração de assinatura');
    setOpen(!open);
  };

  return (
    <>
      {open && <ModalAssinatura open={open} close={handleChange} />}
      <UserCardContainer>
        <Stack
          direction="column"
          justifyContent='flex-start'
          alignItems='flex-start'
          spacing={.5}
        >
          <Avatar
            alt="pic profile"
            src={userData.profilePhoto}
            sx={{ width: 56, height: 56, backgroundColor: 'white' }}
          />
          <Button
            size='small'
            variant='outlined'
            color='secondary'
            onClick={handleChange}
            style={{ display: `${isHidden || !userData.aprovador ? 'none' : ''}` , textTransform: 'none', fontSize: 12, padding: '2px 8px' }}
          >
            Configurar assinatura
            &nbsp;<EditIcon color='info' />
          </Button>
          {!isHidden && (
            <>
              <Typography variant='subtitle1' sx={{ color: 'white' }} fontWeight={600}>{userData.userName}</Typography>
              <Typography variant='subtitle2' sx={{ color: '#7894A8' }}>{userData.email}</Typography>
              <Typography variant='subtitle2' sx={{ color: '#7894A8' }}>{`${t('profile')}: ${userData.role}`}</Typography>
              <Typography variant='subtitle2' sx={{ color: '#7894A8' }}>{`${t('company')}: ${userData.companyName}`}</Typography>
            </>
          )}
        </Stack>
      </UserCardContainer>
    </>
  );
}
